import { defineMessages } from '@/i18n'

export const messages = defineMessages({
  ru: {
    a11yOpenCourseMenu: 'Открыть меню курса',
    settings: 'Настройки',
    stats: 'Статистика',
    delete: 'Удалить',
    statusDraft: 'Черновик',
    statusPublished: 'В каталоге',
    statusLink: 'По ссылке',
  },
  en: {
    a11yOpenCourseMenu: 'Open course menu',
    settings: 'Settings',
    stats: 'Statistics',
    delete: 'Delete',
    statusDraft: 'Draft',
    statusPublished: 'In catalog',
    statusLink: 'By link',
  },
})
